import { connect } from 'react-redux';
import { addFutureChanged } from '../actions';
import AddFutureItems from '../components/AddFutureItems';

const mapStateToProps = (state, { form, dimensionFilter, ...rest }) => {
    const { activeMemberType } = state.teamManagement;
    const addFuture = dimensionFilter
        ? state.teamManagement.dimensionFilters[form] && state.teamManagement.dimensionFilters[form].addFuture
        : state.teamManagement[form].addFuture;
    return {
        activeMemberType,
        addFuture,
        ...rest,
    };
};

const mapDispatchToProps = (dispatch, { form, dimensionFilter }) => {
    return {
        onChange: (...args) => {
            dispatch(addFutureChanged(form, dimensionFilter, ...args));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(AddFutureItems);
